export default __webpack_public_path__ + "static/media/Union.e336ee1a.svg";